import axios from '@/config/httpConfig'
// 工作量排行
export function queryWorkloadRank(data) {
    return axios.post('/project/queryWorkloadRank', data)
}